module.exports = __webpack_public_path__ + "img/avatar3.4dd5f893.png";